import { render } from "./SecondReferenceCard.vue?vue&type=template&id=b6abe094&scoped=true"
import script from "./SecondReferenceCard.vue?vue&type=script&lang=js"
export * from "./SecondReferenceCard.vue?vue&type=script&lang=js"

import "./SecondReferenceCard.vue?vue&type=style&index=0&id=b6abe094&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6abe094"]])

export default __exports__